<template>
  <v-dialog
    max-width="800"
    :value="value"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown"
    @keydown.esc="close(selectedItem)"
  >
    <v-card tile v-if="value">
      <v-app-bar dark flat color="primary">
        <v-btn icon dark @click="close(selectedItem)">
          <v-icon>close</v-icon>
        </v-btn>
        <span class="title">{{
          value.selectedItem
            ? resx.labels.edit + " " + resx.labels.vehiclesType.toLowerCase()
            : resx.labels.newVehicleType
        }}</span>
      </v-app-bar>
      <form @submit.prevent="save()" novalidate>
        <v-card-text>
          <v-container grid-list-xl>
            <v-row wrap>
              <v-col cols="12" md="6">
                <v-text-field
                  data-vv-name="name"
                  :data-vv-as="resx.labels.name"
                  :label="resx.labels.name"
                  :error-messages="errors.collect('name')"
                  v-model="selectedItem.name"
                  v-validate="'required'"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <comments-component
                  v-model="selectedItem.comments"
                  mode="edit"
                  :label="resx.labels.comments"
                  @input="selectedItem.comments = $event"
                />
              </v-col>
              <v-col cols="12">
                <select-obligations
                  v-model="selectedItem.obligations"
                  :obligations="obligations"
                ></select-obligations>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close(selectedItem)">{{ resx.labels.cancel }}</v-btn>
          <v-btn
            class="primary"
            type="submit"
            :disabled="
              !isValidForm ||
                !selectedItem.obligations ||
                selectedItem.obligations.length == 0
            "
            >{{ resx.labels.ok }}</v-btn
          >
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
"use strict";

import vehicleTypeService from "@/services/VehicleTypeService";
import { sprintf } from "sprintf-js";
import commentsComponent from "@/components/common/comments.vue";
import selectObligations from "@/components/common/select-obligations.vue";

export default {
  name: "edit-vehicle-type",
  async mounted() {
    this.obligations = await vehicleTypeService.getObligations();
  },
  components: {
    commentsComponent,
    selectObligations
  },
  data() {
    return {
      menu: false,
      obligations: [],
      dueDateType: [],
      datePicked: null,
      loading: false,
      search: "",
      selectedItem: null,
      originalSelectedItem: null,
      vehicleType: null
    };
  },
  methods: {
    async save() {
      let result = null;
      let payload = Object.assign({}, this.selectedItem);
      if (!this.selectedItem._id) {
        result = await vehicleTypeService.create(payload);
        this.$emit("save", { isNew: true, item: result });
      } else {
        result = await vehicleTypeService.edit(payload);
        this.$emit("save", { isNew: false, item: result });
      }
    },
    async close(vehicleType) {
      if (JSON.stringify(this.originalSelectedItem) != JSON.stringify(this.selectedItem)) {
        await this.botConfirmDialog({
          title: `${this.resx.labels.edit}
          ${this.resx.labels.vehiclesType.toLowerCase()}`,
          content: sprintf(
          this.resx.messages.noSavedChanges,
          vehicleType.name
          )
        })
        this.$emit("close");
      } else {
        this.$emit("close");
      }
    },
    querySelections(v) {
      this.loading = true;
      setTimeout(() => {
        this.items = this.obligations.filter(e => {
          return (
            (e.name || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1
          );
        });
        this.loading = false;
      }, 500);
    }
  },
  props: ["value"],
  watch: {
    search(val) {
      val && this.querySelections(val);
    },
    value(val) {
      this.selectedItem =
        val && val.selectedItem ? Object.assign({}, val.selectedItem) : {};
      this.originalSelectedItem = Object.assign({}, this.selectedItem);
    }
  }
};
</script>
